import { render, staticRenderFns } from "./TwelveTable.vue?vue&type=template&id=04cf5cf1&"
import script from "./TwelveTable.vue?vue&type=script&lang=js&"
export * from "./TwelveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports